import { DetailsOfClaimant } from '../../../shared/components/account-request-and-pod-submission/details-claimant/details-claimant.model';
import { ParticularsOfDebtClaims } from '../../../shared/components/account-request-and-pod-submission/particulars-dept/particulars-dept.model';
import { ParticularsOfInterest } from '../../../shared/components/account-request-and-pod-submission/particulars-interest/particulars-interest.model';
import { SecurityHeld } from '../../../shared/components/account-request-and-pod-submission/securities-held/securities-held.model';
import { DetailsOfAuthorisedRepresentative } from '../../../shared/components/account-request-and-pod-submission/details-author/details-author.model';
import { SummaryLog } from 'src/app/shared/models/CreditorClaimSummaryLog';



export class PreOnBoarding {
    detailsOfAuthorizedRepresentative: DetailsOfAuthorisedRepresentative = new DetailsOfAuthorisedRepresentative();
    detailsOfClaimant:DetailsOfClaimant = new DetailsOfClaimant();
    particularsOfDebtClaims: ParticularsOfDebtClaims[] = [];
    particularsofInterest: ParticularsOfInterest[]=[];
    securityHeld: SecurityHeld[]=[];
    particularsOfDebt: ParticularsOfDebt= new ParticularsOfDebt();
    createdDatetime:any;
    createdBy:any;
    updatedDatetime:any;
    updatedBy:any;
    formId : number;
    companyName: string;
    creditorUEN: string;
    summaryLog: SummaryLog;
}

export class ParticularsOfDebt {
    id?: number;
    preOnboardingCreditorId?: string;
    originalFileName: string;
    filePath?: string;
    IsDraft?: boolean;
    createdBy?: string;
    createdOn?: Date;
    updatedBy?: string;
    updatedOn?: Date;
    particularsOfDebtStatusId: any;
    withdrawnParticularsOfDebtId: any;
    reasonForDeactivationId: number;
    reasonForDeactivation: string;
    creditorId: any;
    withdrawlDate: any;
  }
